"use client";

import Image from "next/image";

type Props = {
    document: any;
    lang: String;
}

export const Document = ({document, lang}: Props) => {
   console.log(document);
    const DownloadText  = (lang === 'fr') ? 'Télécharger' : 'Download';
    const FlagFr = (lang === 'fr') ? 'Drapeau français' : 'French flag';
    const FlagEn = (lang === 'fr') ? 'Drapeau anglais' : 'English flag';
    return (
        <div className='m-product__documents__item'>
            <p className='m-product__documents__item__name'>
                <span className='m-product__documents__item__name__text'>{document.category.label}</span>
                <Image width={24} height={16} src={(document.lang === 'fr') ? '/flag-fr.svg' : '/flag-en.svg'} className='m-product__documents__item__name__flag' alt={(document.lang === 'fr') ? FlagFr : FlagEn} />
            </p>
            <a href={document.publicUrl} target="_blank" className='m-product__documents__item__download'>
                <span className='icon-download m-product__documents__item__download__icon' aria-hidden="true"></span>
                <span className='m-product__documents__item__download__text'>{DownloadText}</span>
            </a>
        </div>
    )
}

export default Document